export interface BooleanFlag {
  key: string;
  type: "boolean";
  /** Served when Flipt is unreachable, init timed out, or evaluation fails. */
  defaultValue: boolean;
}

export interface VariantFlag {
  key: string;
  type: "variant";
  /** Served when Flipt is unreachable, init timed out, or evaluation fails. */
  defaultVariant: string;
}

export const FeatureFlags = {
  CASHBACK_V2_ENABLED: { key: "cashback-v2-enabled", type: "boolean", defaultValue: false },
  ADMIN_CASHBACK_V2_CREATE_DEFAULT: { key: "admin-cashback-v2-create-default", type: "boolean", defaultValue: true },
  BONUS_V1_CASHBACK_PAYOUT_MODE: { key: "bonus-v1-cashback-payout-mode", type: "variant", defaultVariant: "pay" },
  CASHBACK_V2_PAYOUT_MODE: { key: "cashback-v2-payout-mode", type: "variant", defaultVariant: "shadow" },
  /** Off by default: the admin-mcp chat backend is not deployed everywhere yet. */
  AI_CHAT: { key: "admin-ai-chat", type: "boolean", defaultValue: false },
  /**
   * Second gate after AI_CHAT for the chat's page-form bridge (snapshot + fill). Off by default so the
   * form loop can ship dark and be enabled per environment once the admin-mcp side is deployed.
   */
  AI_CHAT_FORMS: { key: "admin-ai-chat-forms", type: "boolean", defaultValue: false },
  /**
   * Gates the admin control for configuring the enforced style. On by default so operators can set a style
   * before any player sees it — harmless with no style set. A dedicated flag rather than the player rollout
   * key because AF evaluates Flipt with an empty context and so can never match a rollout segment.
   */
  ADMIN_CASINO_ENFORCED_THUMBNAIL_STYLE: { key: "admin-casino-enforced-thumbnail-style", type: "boolean", defaultValue: true },
} as const satisfies Record<string, BooleanFlag | VariantFlag>;
